import React from "react";
import * as Styles from "./box.styles";

export const Box = (props) => {
  return (
    <Styles.Wrapper variant={props.variant}>{props.children}</Styles.Wrapper>
  );
};
